import React from 'react';
import { FieldFeedbackLabel } from './FieldFeedbackLabel';

const getFieldCSSClasses = (touched, errors, hideBorderGreen = false) => {
  const classes = [
    'w-full h-11 pl-3 pr-8 mt-2 text-sm font-regular text-gray-600 border rounded-md border-gray-300 hover:bg-gray-50 focus:outline-none focus:border-mainBlue placeholder:text-gray-400 disabled:bg-gray-100 disabled:text-opacity disabled:text-gray-600 disabled:text-opacity-60 disabled:border-opacity-70 disabled:bg-opacity-70',
  ];

  if (touched && errors) {
    classes.push('border-2 border-red-500 mt-2');
  }

  if (touched === true && errors === undefined && !hideBorderGreen) {
    classes.push('border-2 border-green-500');
  }

  return classes.join(' ');
};

export function TextInput({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label,
  withFeedbackLabel = false,
  hideBorderGreen = false,
  darkMode = false,
  customFeedbackLabel,
  externalDivClassName = '',
  type = 'text',
  ...props
}) {
  return (
    <>
      <div className={externalDivClassName}>
        {label && (
          <label
            htmlFor={label}
            className={`${
              darkMode ? 'text-white' : 'text-gray-500'
            } text-sm font-semibold`}
          >
            {' '}
            {label}{' '}
          </label>
        )}
        <div className=''>
          <input
            type={type}
            {...field}
            {...props}
            className={getFieldCSSClasses(
              touched[field.name],
              errors[field.name],
              hideBorderGreen,
              darkMode
            )}
          />
          {withFeedbackLabel && errors[field.name] && (
            <FieldFeedbackLabel
              error={errors[field.name]}
              touched={touched[field.name]}
              label={label}
              type={type}
              customFeedbackLabel={customFeedbackLabel}
            />
          )}
        </div>
      </div>
    </>
  );
}
